import { InferType, string } from 'yup';

export const usernameSchema = string()
  .min(3, 'minLength')
  .max(17, 'maxLength')
  .matches(/^[a-zA-Z0-9-_.]+$/, 'specialSymbol')
  .required();

export type UsernameSchema = InferType<typeof usernameSchema>;

export const UsernameValidationMessage: Record<string, string> = {
  exist: 'This nickname has already been registered.',
  maxLength: 'Up to 17 characters are available.',
  minLength: 'Nickname must be at least 3 characters.',
  specialSymbol: 'Only letters, numbers and special characters("-", "_", ".") are allowed.',
  'api.user.profile.duplicatedNickname': 'Username already taken, enter a different username',
};
